module.exports = __webpack_public_path__ + "static/media/laura_nogue2.33191fb1.png";